<section class="modal modal--{{modalData.type}}">
  <div class="modal-dialog w-500">
    <div class="modal-content">
      <div class="modal-header">
        <div class="flex-always flex--space-between">
          <p class="modal-title">
            {{ appCopy.panelHeader["hubdropInfoTitle" + selectedLanguage] }}
          </p>
          <a href="javascript:void(0);" class="modal-close" (click)="close($event)"><i class="icon">cross</i></a>
        </div>
      </div>
      <div class="modal-body">
        <ul class="padding-left-12">
          <li>
            {{ appCopy.panelHeader["hubdropInfoLine1" + selectedLanguage] }}
          </li>
          <li class="padding-bottom-16 padding-top-16">
            {{ appCopy.panelHeader["hubdropInfoLine2" + selectedLanguage] }}
          </li>
          <li>
            {{ appCopy.panelHeader["hubdropInfoLine3" + selectedLanguage] }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
